(function() {
  // Function to filter facet items
  function filterFacets(input) {
    const searchValue = input.value.toLowerCase();
    const list = input.closest('.facets__display, .mobile-facets__submenu')
                      .querySelectorAll('li');

    list.forEach(item => {
      const label = item.textContent.toLowerCase();
      item.style.display = label.includes(searchValue) ? '' : 'none';
    });
  }

  // Save typed value
  function saveValue(e) {
    if (!e.target.matches('[data-facet-search]')) return;
    localStorage.setItem('facetSearchValue', e.target.value);
    filterFacets(e.target);
  }

  document.addEventListener('input', saveValue);

  // Restore value and filter items
  function restoreFilters() {
    const storedValue = localStorage.getItem('facetSearchValue') || '';
    document.querySelectorAll('[data-facet-search]').forEach(input => {
      input.value = storedValue;
      filterFacets(input);
    });

    // Keep filter sections open
    document.querySelectorAll('.filter__heading').forEach(heading => {
      heading.classList.add('is-open');
    });
  }

  // MutationObserver to watch for DOM changes in facets container
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function() {
      restoreFilters();
    });
  });

  const facetsContainers = document.querySelectorAll('.facets, .mobile-facets__submenu');
  facetsContainers.forEach(container => {
    observer.observe(container, { childList: true, subtree: true });
  });

  // Also run on page load
  document.addEventListener('DOMContentLoaded', restoreFilters);
})();
